// import React, { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import {
//   Receipt,
//   ArrowLeft,
//   HandCoins,
//   Mail,
//   Smartphone,
//   Puzzle,
//   PenLine,
// } from "lucide-react";

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { grampanchayatName = "ग्रामपंचायत", arthikVarshLabel = "२०२४-२५" } =
//     location.state || {};

//   const [showKarPavthiIcons, setShowKarPavthiIcons] = useState(false);
//   const [showItarVyavaharIcons, setShowItarVyavaharIcons] = useState(false);

//   const menuItems = [
//     {
//       id: "kayam-mahiti",
//       title: "कायम माहिती",
//       icon: <Puzzle className="w-8 h-8" />,
//       description: "मालमत्ता आणि कर आकारणी",
//       path: "/milakhatnondani",
//       color: "from-blue-500 to-cyan-500",
//     },
//     {
//       id: "vyavahar",
//       title: "व्यवहार",
//       icon: <Puzzle className="w-8 h-8" />,
//       description: "दैनंदिन व्यवहार आणि पावत्या",
//       path: "state-change",
//       action: () => setShowKarPavthiIcons(true),
//       color: "from-emerald-500 to-teal-500",
//     },
//     {
//       id: "report",
//       title: "रिपोर्ट",
//       icon: <Puzzle className="w-8 h-8" />,
//       description: "अहवाल आणि माहिती",
//       path: "#",
//       color: "from-orange-500 to-amber-500",
//     },
//     {
//       id: "nondani",
//       title: "नोंदणी",
//       icon: <PenLine className="w-8 h-8" />,
//       description: "नवीन नोंदणी",
//       path: "#",
//       color: "from-purple-500 to-indigo-500",
//     },
//     {
//       id: "arthik-report",
//       title: "आर्थिक रिपोर्ट",
//       icon: <Puzzle className="w-8 h-8" />,
//       description: "आर्थिक स्थिती अहवाल",
//       path: "/arthik-report",
//       color: "from-rose-500 to-pink-500",
//     },
//     {
//       id: "sms-utility",
//       title: "SMS Utility",
//       icon: <Mail className="w-8 h-8" />,
//       description: "संदेश सेवा",
//       path: "#",
//       color: "from-gray-700 to-gray-900", // Darker for utility?
//     },
//     {
//       id: "gsconnect",
//       title: "GSConnect कागरीक सुविधा",
//       icon: <Smartphone className="w-8 h-8" />,
//       description: "नागरिक सेवा पोर्टल",
//       path: "#",
//       color: "from-blue-600 to-indigo-600",
//     }
//   ];

//   const karPavthiItems = [
//     {
//       id: "kar-pavthi",
//       title: "कर पावती",
//       icon: <Receipt className="w-8 h-8" />,
//       description: "कर भरणा पावती",
//       path: "/tax-receipt",
//       color: "from-indigo-500 to-purple-500",
//     },
//     // { name: "शुल्क पावती", icon: Coins },
//     // { name: "जमा व्यवहार", icon: Wallet },
//     // { name: "उधार व्यवहार", icon: CreditCard },
//     // { name: "रोख व्यवहार", icon: DollarSign },
//     {
//       id: "itar-vyavahar",
//       title: "इतर व्यवहार",
//       icon: <HandCoins className="w-8 h-8" />,
//       description: "इतर जमा आणि खर्च व्यवहार",
//       path: "state-change",
//       action: () => setShowItarVyavaharIcons(true),
//       color: "from-rose-500 to-pink-500",
//     },
//   ];

//   const itarVyavaharItems = [
//     {
//       id: "rokh-jama",
//       title: "रोख जमा",
//       icon: <Mail className="w-8 h-8" />, // Placeholder icon replaced
//       description: "रोख जमा व्यवहार",
//       path: "/Rokhjama",
//       color: "from-cyan-500 to-blue-500",
//     },
//     {
//       id: "rokh-nave",
//       title: "रोख नावे",
//       icon: <Mail className="w-8 h-8" />,
//       description: "रोख नावे व्यवहार",
//       path: "/Rokhnave",
//       color: "from-blue-500 to-indigo-500",
//     },
//     {
//       id: "dhanadesh-jama",
//       title: "धनादेश जमा",
//       icon: <Mail className="w-8 h-8" />,
//       description: "बँक जमा व्यवहार",
//       path: "/Dhandeshjama",
//       color: "from-teal-500 to-emerald-500",
//     },
//     {
//       id: "dhanadesh-nave",
//       title: "धनादेश नावे",
//       icon: <Mail className="w-8 h-8" />,
//       description: "बँक नावे व्यवहार",
//       path: "/tax-receipt",
//       color: "from-emerald-500 to-green-500",
//     },
//     {
//       id: "jv",
//       title: "जे.व्ही",
//       icon: <Mail className="w-8 h-8" />,
//       description: "जर्नल व्हाउचर",
//       path: "/tax-receipt",
//       color: "from-amber-500 to-orange-500",
//     },
//   ];

//   // Helper to get current items based on state
//   const getCurrentItems = () => {
//     if (showItarVyavaharIcons) return itarVyavaharItems;
//     if (showKarPavthiIcons) return karPavthiItems;
//     return menuItems;
//   };

//   const handleBack = () => {
//     if (showItarVyavaharIcons) {
//       setShowItarVyavaharIcons(false);
//     } else if (showKarPavthiIcons) {
//       setShowKarPavthiIcons(false);
//     } else {
//       navigate("/grampanchayatnivaad");
//     }
//   };

//   const currentItems = getCurrentItems();
//   const pageTitle = showItarVyavaharIcons
//     ? "इतर व्यवहार"
//     : showKarPavthiIcons
//     ? "व्यवहार - कर पावती"
//     : "मुख्य पृष्ठ";

//   return (
//     <div className="min-h-screen bg-gray-50 p-6 md:p-8">
//       {/* Header */}
//       <div className="max-w-7xl mx-auto mb-10">
//         <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
//           <div>
//             <h1 className="text-3xl font-bold mb-2">{pageTitle}</h1>
//             <p className="text-slate-300">
//               {grampanchayatName} | आर्थिक वर्ष: {arthikVarshLabel}
//             </p>
//           </div>
//           <button
//             onClick={handleBack}
//             className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm flex items-center gap-2"
//           >
//             <ArrowLeft size={16} />
//             मागे जा
//           </button>
//         </div>
//       </div>

//       {/* Menu Grid */}
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {currentItems.map((item) => (
//           <div
//             key={item.id}
//             onClick={() => {
//               if (item.path === "state-change" && item.action) {
//                 item.action();
//               } else if (item.path !== "#") {
//                 navigate(item.path, { state: location.state });
//               }
//             }}
//             className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
//           >
//             <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
//             <div className="p-6">
//               <div
//                 className={`w-16 h-16 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}
//               >
//                 {item.icon}
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
//                 {item.title}
//               </h3>
//               <p className="text-gray-500 text-sm">{item.description}</p>
//             </div>
//             <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
//               <span className="text-sm font-medium text-gray-600 group-hover:text-blue-600 transition-colors">
//                 निवडा
//               </span>
//               <svg
//                 className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-all duration-300"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M17 8l4 4m0 0l-4 4m4-4H3"
//                 />
//               </svg>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;








import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Receipt,
  ArrowLeft,
  HandCoins,
  Mail,
  Smartphone,
  Puzzle,
  PenLine,
} from "lucide-react";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { grampanchayatName = "ग्रामपंचायत", arthikVarshLabel = "२०२४-२५" } =
    location.state || {};

  const [showKarPavthiIcons, setShowKarPavthiIcons] = useState(false);
  const [showItarVyavaharIcons, setShowItarVyavaharIcons] = useState(false);

  const menuItems = [
    {
      id: "kayam-mahiti",
      title: "कायम माहिती",
      icon: <Puzzle className="w-8 h-8" />,
      description: "मालमत्ता आणि कर आकारणी",
      path: "/milakhatnondani",
      color: "from-blue-500 to-cyan-500",
    },
    {
      id: "vyavahar",
      title: "व्यवहार",
      icon: <Puzzle className="w-8 h-8" />,
      description: "दैनंदिन व्यवहार आणि पावत्या",
      path: "state-change",
      action: () => setShowKarPavthiIcons(true),
      color: "from-emerald-500 to-teal-500",
    },
    {
      id: "report",
      title: "रिपोर्ट",
      icon: <Puzzle className="w-8 h-8" />,
      description: "अहवाल आणि माहिती",
      path: "/report",
      color: "from-orange-500 to-amber-500",
    },
    {
      id: "nondani",
      title: "नोंदणी",
      icon: <PenLine className="w-8 h-8" />,
      description: "नवीन नोंदणी",
      path: "#",
      color: "from-purple-500 to-indigo-500",
    },
    {
      id: "arthik-report",
      title: "आर्थिक रिपोर्ट",
      icon: <Puzzle className="w-8 h-8" />,
      description: "आर्थिक स्थिती अहवाल",
      path: "/aarthikreport",
      color: "from-rose-500 to-pink-500",
    },
    {
      id: "sms-utility",
      title: "SMS Utility",
      icon: <Mail className="w-8 h-8" />,
      description: "संदेश सेवा",
      path: "#",
      color: "from-gray-700 to-gray-900", // Darker for utility?
    },
    {
      id: "gsconnect",
      title: "GSConnect कागरीक सुविधा",
      icon: <Smartphone className="w-8 h-8" />,
      description: "नागरिक सेवा पोर्टल",
      path: "#",
      color: "from-blue-600 to-indigo-600",
    }
  ];

  const karPavthiItems = [
    {
      id: "kar-pavthi",
      title: "कर पावती",
      icon: <Receipt className="w-8 h-8" />,
      description: "कर भरणा पावती",
      path: "/tax-receipt",
      color: "from-indigo-500 to-purple-500",
    },
    // { name: "शुल्क पावती", icon: Coins },
    // { name: "जमा व्यवहार", icon: Wallet },
    // { name: "उधार व्यवहार", icon: CreditCard },
    // { name: "रोख व्यवहार", icon: DollarSign },
    {
      id: "itar-vyavahar",
      title: "इतर व्यवहार",
      icon: <HandCoins className="w-8 h-8" />,
      description: "इतर जमा आणि खर्च व्यवहार",
      path: "/othertransactions",
      color: "from-rose-500 to-pink-500",
    },
  ];

  const itarVyavaharItems = [
    {
      id: "rokh-jama",
      title: "रोख जमा",
      icon: <Mail className="w-8 h-8" />, // Placeholder icon replaced
      description: "रोख जमा व्यवहार",
      path: "/othertransactions",
      color: "from-cyan-500 to-blue-500",
    },
    {
      id: "rokh-nave",
      title: "रोख नावे",
      icon: <Mail className="w-8 h-8" />,
      description: "रोख नावे व्यवहार",
      path: "/Rokhnave",
      color: "from-blue-500 to-indigo-500",
    },
    {
      id: "dhanadesh-jama",
      title: "धनादेश जमा",
      icon: <Mail className="w-8 h-8" />,
      description: "बँक जमा व्यवहार",
      path: "/Dhandeshjama",
      color: "from-teal-500 to-emerald-500",
    },
    {
      id: "dhanadesh-nave",
      title: "धनादेश नावे",
      icon: <Mail className="w-8 h-8" />,
      description: "बँक नावे व्यवहार",
      path: "/tax-receipt",
      color: "from-emerald-500 to-green-500",
    },
    {
      id: "jv",
      title: "जे.व्ही",
      icon: <Mail className="w-8 h-8" />,
      description: "जर्नल व्हाउचर",
      path: "/tax-receipt",
      color: "from-amber-500 to-orange-500",
    },
  ];

  // Helper to get current items based on state
  const getCurrentItems = () => {
    if (showItarVyavaharIcons) return itarVyavaharItems;
    if (showKarPavthiIcons) return karPavthiItems;
    return menuItems;
  };

  const handleBack = () => {
    if (showItarVyavaharIcons) {
      setShowItarVyavaharIcons(false);
    } else if (showKarPavthiIcons) {
      setShowKarPavthiIcons(false);
    } else {
      navigate("/grampanchayatnivaad");
    }
  };

  const currentItems = getCurrentItems();
  const pageTitle = showItarVyavaharIcons
    ? "इतर व्यवहार"
    : showKarPavthiIcons
    ? "व्यवहार - कर पावती"
    : "मुख्य पृष्ठ";

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">{pageTitle}</h1>
            <p className="text-slate-300">
              {grampanchayatName} | आर्थिक वर्ष: {arthikVarshLabel}
            </p>
          </div>
          {/* <button
            onClick={handleBack}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm flex items-center gap-2"
          >
            <ArrowLeft size={16} />
            मागे जा
          </button> */}
        </div>
      </div>

      {/* Menu Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {currentItems.map((item) => (
          <div
            key={item.id}
            onClick={() => {
              if (item.path === "state-change" && item.action) {
                item.action();
              } else if (item.path !== "#") {
                navigate(item.path, { state: location.state });
              }
            }}
            className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
          >
            <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
            <div className="p-6">
              <div
                className={`w-16 h-16 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}
              >
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-500 text-sm">{item.description}</p>
            </div>
            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
              <span className="text-sm font-medium text-gray-600 group-hover:text-blue-600 transition-colors">
                निवडा
              </span>
              <svg
                className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-all duration-300"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
